angular.module('zc.commonApi')

.factory "Template", ($resource, $q, BaseProjectCrudService) ->
  class Template extends BaseProjectCrudService

  new Template(
    $resource
    $q
    "/api/projects/:projectId/templates"
    "template"
    "templates"
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/template_service.js.coffee